export default "__VITE_ASSET__DYLSN8bF__"